module.exports = ".footer-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/footer/footer.component.scss
// module id = ./src/app/layouts/footer/footer.component.scss
// module chunks = main